import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getDownloadURL } from '@api/common';

import { fileSaver } from '@utils/fileSaver';

import { IId } from '@interfaces/common/common';

import { ESnackbarTypes } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { DOWNLOAD_FILE, DOWNLOAD_URL } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import { useMutation, useQuery } from '../reactQuery';

export const useDownloadFile = (params?: IId<string | null | undefined>) => {
	const { id } = params || {};
	const dispatch = useAppDispatch();

	const {
		data,
		isLoading: isLoadingDownloadURL,
		isFetching: isFetchingDownloadURL,
	} = useQuery({
		queryKey: [DOWNLOAD_URL, id],
		queryFn: () => getDownloadURL(id!),
		enabled: [!!id],
		...refetchOptions,
	});

	const { mutate: downloadFile } = useMutation<string>({
		mutationKey: [DOWNLOAD_FILE],
		mutationFn: (id: string) => getDownloadURL(id).then((data) => {
			if (data?.downloadUrl) fileSaver(data.downloadUrl);
		}).catch(err => {
			dispatch(setSnackbar({
				message: err?.message || responseMessages.error,
				type: ESnackbarTypes.error,
			}));
		}),
	});

	return {
		downloadUrl: id ? data?.downloadUrl : '',
		isLoadingDownloadURL: isLoadingDownloadURL && isFetchingDownloadURL,
		downloadFile,
	};
};
